export enum Status {
  COMPLETE = "complete",
  INCOMPLETE = "incomplete"
}

export const KEY_ALERT_MODAL = "alert_modal";
